"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onOpenWhatsAppContactGbc = exports.openUrlWithBlank = void 0;
function openUrlWithBlank(path) {
    window.open(path, '_blank');
}
exports.openUrlWithBlank = openUrlWithBlank;
function onOpenWhatsAppContactGbc(message) {
    var url = "https://wa.me/+595991712103?text=".concat(message !== null && message !== void 0 ? message : 'Hola tengo una consulta', ", ");
    openUrlWithBlank(url);
}
exports.onOpenWhatsAppContactGbc = onOpenWhatsAppContactGbc;
